import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBankList extends Layout {
    layoutheaderBanks: LayoutHeader;
    sourceBank: DataSource;
    tableBanks: Table;
}
